import { CreateFunctionDTO } from '../dtos';

export const defaultValues: CreateFunctionDTO = {
    name: '',
    roles: [],
    observation: '',
};
